// ProductSelector.js
import React, { useEffect }  from 'react';
//import DOMPurify from 'dompurify';
import ProductItem from './ProductItem';

const ProductSelector = ({ productSelectorHeadline = '', ProductItems = []}) => {

	useEffect(() => {
		window.applicationReInit(['Tabs']);
	}, [ProductItems]);

	return (
		<div className="c-tabs js-tabs l-grid l-grid--max-width">
			{productSelectorHeadline && (
				<div className="l-grid__row">
					<div className="l-grid__column-large-8 offset-large-2">
						<h2 className="c-heading u-text-align-center u-margin-bottom-10 ">
							{productSelectorHeadline}
						</h2>
					</div>
				</div>
			)}
			<div className="l-grid__row">
				<ul className="c-tabs__nav l-grid__column-small-12 " role="tablist">
					{ProductItems && ProductItems.map((item, index) => (
						<li key={index} className={`c-tabs__nav-item ${index === 0 ? 'active' : ''}`} tabIndex={index === 0 ? '0' : '-1'} data-content-id={`Content-${index}`} role="tab">
							{/* eslint-disable-next-line */}
							<input id={`Input-${index}`} tabIndex="-1" className="c-tabs__input" aria-controls={`Content-${index}`} name="productselectortabs" type="radio" checked={index === 0} readOnly aria-selected="true" />
							<label id={`Tab-${index}`} tabIndex="-1" htmlFor={`Input-${index}`} className="c-tabs__label ">
								<div className="c-tabs__label-container">
									{item.navigationTabName}
								</div>
								<span aria-hidden="true" className="c-tabs__icon c-icon c-icon--chevron-down"></span>
								<span aria-hidden="true" className="c-tabs__icon c-icon c-icon--chevron-up"></span>
							</label>

							<div className="c-tabs__content-item u-hidden-medium-up">
								<ProductItem item={item} />
							</div>
						</li>
					))}						
				</ul>
				<div className="c-tabs__content offset-large-1 offset-medium-1 l-grid__column-large-10 l-grid__column-medium-10 u-hidden-small-down" tabIndex="0">
				{ProductItems && ProductItems.map((item, index) => (
					<div key={index} id={`Content-${index}`} className={`c-tabs__content-item ${index === 0 ? 'active' : ''}`} aria-labelledby={`Tab-${index}`} role="tabpanel">
					<ProductItem item={item} />
					</div>
				))}
				</div>
			</div>
		</div>
	);
}

export default ProductSelector;


